<div class="row">
	<div *ngFor="let learn of learns; let index" class="col-lg-3">
		<kt-learn-content-card
			(btnClick)="learnClick.emit($event)"
			[learn]="learn"
		></kt-learn-content-card>
	</div>
</div>
